import { render } from "./MediaYoutube.vue?vue&type=template&id=8da7ce46"
import script from "./MediaYoutube.vue?vue&type=script&lang=js"
export * from "./MediaYoutube.vue?vue&type=script&lang=js"

import "./MediaYoutube.vue?vue&type=style&index=0&id=8da7ce46&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.27_webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__